import {Image} from './image';
import {Content} from './content';
import {MapView} from './map-view';

export class CommunityInfo {
  images: Image[] = [];
  externalLinks: ExternalLink[];

  mainInfo: Content;
  generalInfo: Content;
  mapView: MapView;

  constructor(public data: any) {
    const json: JSON = data['community'];

    if (data['externalLinks']) {
      for (const link of json['externalLinks']) {
        this.externalLinks.push(new ExternalLink(link));
      }
    }

    for (const image of json['mainView']['images']) {
      this.images.push(new Image(image));
    }

    if (json['mainView']['rightContent']) {
      this.mainInfo = new Content(json['mainView']['rightContent']);
    }
    if (json['generalInfoView']) {
      this.generalInfo = new Content(json['generalInfoView']);
    }
    if (json['mapView']) {
      this.mapView = new MapView(json['mapView']);
    }
  }
}

export class ExternalLink {
  title: string;
  url: string;

  constructor(public data: any) {
    const json: JSON = data;

    this.title = json['title'];
    this.url = json['url'];
  }
}



// WEBPACK FOOTER //
// ./src/app/model/community-info.ts